"use client";
import "@99power/site-assistant/chat.css";
import { AssistantChat } from "@99power/site-assistant/react";
import { useGlobalChat } from "@/hooks/use-chat-context";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import ChatCookieConsent from "./chat-consent";
import { captureClientEvent } from "@/lib/telemetry-client";
export default function ChatWidget({ onInit }: { onInit?: boolean }) {
  const chat = useGlobalChat();
  return (
    <AssistantChat
      chat={chat}
      Consent={ChatCookieConsent}
      className="relative h-full"
      renderContent={(content) => (
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            a: ({ node, ...props }) => <a {...props} className="underline" />,
          }}
        >
          {content}
        </ReactMarkdown>
      )}
      renderTool={(tool) => <p>{tool.result?.message}</p>}
      onSubmit={() =>
        captureClientEvent("chat_message_submitted", {
          length: chat.input.length,
        })
      }
    />
  );
}
